import { SnackbarProvider as LibSnackbarProvider } from 'notistack';
import * as React from 'react';

import { SnackbarItem } from './SnackbarItem';
import { SnackbarSurveyItem } from './SnackbarSurveyItem';

type SnackbarProviderProps = {
  children: React.ReactNode | Array<React.ReactNode>;
};

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => (
  <LibSnackbarProvider
    // React 19: forwardRef is deprecated, pass ref as a standard prop
    Components={{
      default: SnackbarItem,
      error: SnackbarItem,
      info: SnackbarItem,
      warning: SnackbarItem,
      success: SnackbarItem,
      survey: SnackbarSurveyItem,
    }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
  >
    {children}
  </LibSnackbarProvider>
);

export { useSnackbar } from 'notistack';
